// Pick the first defined of two or three arguments.
export function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}
//# sourceMappingURL=defaults.js.map


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/~/ngx-bootstrap/chronos/utils/defaults.js
// module id = ../../../../ngx-bootstrap/chronos/utils/defaults.js
// module chunks = 8